import { gql } from '@apollo/client';

const listUserPreferences = gql`
  query listUserPreferences {
    listUserPreferences {
      id
      type
      enabled
      confirmed
    }
  }
`;

export default listUserPreferences;
